// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__y7Xwe","ellipsis":"styles_ellipsis__DkpxC","text2AndMoreLines":"styles_text2AndMoreLines__LwVCu","tooltipTrigger":"styles_tooltipTrigger__pnNZ6"};